import { CTypeModel } from '@y42/model';
import { ExportTypeEnum } from '../export-type.enum';

/**
 * Export Type objects from contentful
 */
export class ExportCTypeModel extends CTypeModel<ExportTypeEnum> {}

export type ExportTypeModel = ExportCTypeModel;

export const UNKNOWN_EXPORT_TYPE_MODEL: ExportTypeModel = new ExportCTypeModel({
  type: ExportTypeEnum.Unknown,
  rawGuideUrl: '',
  displayName: '',
  description: '',
  logo: '',
  orderNo: 0,
  availabilityLabel: '',
  industry: [],
  color: '',
  articleid: '',
  articleidAuth: '',
  scheduleTime: 0,
  documentationUrl: '',
  isAirbyte: false,
  hasIncremental: false,
  pictureUrl: '',
  authTutorial: '',
});
